// Window chrome owns this look; it only ever renders inside a window body.
import css from '@/wm/Window.module.css';

/**
 * Suspense fallback while an app's chunk downloads. Deliberately plain: on a
 * warm cache it is on screen for a couple of frames, and anything livelier
 * would read as a flash of broken layout.
 */
export function Hourglass() {
  return (
    <div className={css.hourglass} role="status">
      Loading…
    </div>
  );
}
